import script from "./single-background-remover.vue?vue&type=script&setup=true&lang=js"
export * from "./single-background-remover.vue?vue&type=script&setup=true&lang=js"

import "./single-background-remover.vue?vue&type=style&index=0&id=3258c2fd&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3258c2fd"]])

export default __exports__